export type ReportType = "ResultReport" | "RequisitionForm";

export interface ReportDownloadSummary {
    ReqNum: string
    ReportType: ReportType
    DownloadCount: number
    LastDownloadedDate: string
}

export interface ReportDownloadHistory {
    ID: number
    ReqNum: string
    ReportType: ReportType
    DownloadMethod: "Single" | "Bulk"
    UserEmail: string
    UserName: string
    DownloadedDate: string
}

export const REPORT_TYPE_LABELS: { [key in ReportType]: string } = {
    ResultReport: "Result Report",
    RequisitionForm: "Requisition Form",
};
